module.exports = __webpack_public_path__ + "img/AI-TEST-ROOM-03.cea4834c.png";